import { Box, Button, Stack, Typography } from '@mui/material';
import { ReactComponent as LockIcon } from 'assets/icons/Lock.svg';
import { GuaranteesDialog } from 'common/components/GuaranteesDialog/GuaranteesDialog';
import { Image } from 'common/components/Image/Image';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SignatureImage from '../../../assets/images/signature.png';
import { DataProtectionGuarantees } from './DataProtectionGuarantees';
import { styles } from './DataProtectionGuaranteesDialog.styles';

export type DataProtectionGuaranteesDialogProps = DialogComponentProps<boolean>;

export const DataProtectionGuaranteesDialog: FC<DataProtectionGuaranteesDialogProps> = ({
  instanceId,
  isOpen,
  onReject,
  onResolve,
}) => {
  const { t } = useTranslation();

  const content = (
    <Stack spacing={3}>
      <DataProtectionGuarantees />
      <Stack pl={9}>
        <Image src={SignatureImage} width={100} />
        <Typography color="textSecondary" variant="bodyM">
          {t('dataProtectionDialog.signature.name')}
        </Typography>
        <Typography variant="bodyM">{t('dataProtectionDialog.signature.role')}</Typography>
      </Stack>
      <Box sx={styles.buttonContainer}>
        <Button color="primary" onClick={() => onResolve(true)} size="large" sx={styles.button}>
          {t('dataProtectionDialog.button')}
        </Button>
      </Box>
    </Stack>
  );

  return (
    <GuaranteesDialog
      content={content}
      icon={<LockIcon />}
      instanceId={instanceId}
      isOpen={isOpen}
      onReject={() => onReject(false)}
      onResolve={() => onResolve(false)}
      subtitle={t('dataProtectionDialog.subtitle')}
      sx={styles.dialog}
      title={t('dataProtectionDialog.title')}
    />
  );
};
